"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.default = exports.convertNonIntegerToDefault = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _useAfterMount = _interopRequireDefault(require("../../hooks/useAfterMount"));

var _excluded = ["unit", "inputAddon", "className", "bsSize", "disabled", "onValueChanged", "min", "max", "value", "step", "type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var defaultProps = {
  min: 0,
  max: Number.MAX_VALUE,
  value: 0,
  step: 1
};
exports.defaultProps = defaultProps;

var getStepFromProps = function getStepFromProps(propStep, defaultStep, max, min) {
  return Number.isInteger(propStep) && propStep < Math.abs(max - min) ? propStep : defaultStep;
};

var getValueFromProps = function getValueFromProps(val, min, max, fallback) {
  return clampNumber(Number(val), min, max) || fallback;
};

var clampNumber = function clampNumber(number, min, max) {
  if (number < min) {
    return min;
  } else if (number > max) {
    return max;
  }

  return number;
};

var isFormatted = function isFormatted(number) {
  return /^(-)?([1-9]\d*)?$/.test(number) || number === '0';
};

var convertNonIntegerToDefault = function convertNonIntegerToDefault(value, min) {
  var currentValue = value;

  if (!Number.isInteger(currentValue)) {
    currentValue = min;
  }

  return currentValue;
};

exports.convertNonIntegerToDefault = convertNonIntegerToDefault;

var NumberInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var unit = props.unit,
      inputAddon = props.inputAddon,
      className = props.className,
      bsSize = props.bsSize,
      disabled = props.disabled,
      _props$onValueChanged = props.onValueChanged,
      onValueChanged = _props$onValueChanged === void 0 ? function () {} : _props$onValueChanged,
      propMin = props.min,
      propMax = props.max,
      propValue = props.value,
      propStep = props.step,
      propType = props.type,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded); // Breaking change - default is now "number"

  var type = propType === 'text' ? 'text' : 'number';
  var min = Number.isInteger(propMin) ? propMin : defaultProps.min;
  var max = Number.isInteger(propMax) ? propMax : defaultProps.max;
  var value = getValueFromProps(propValue, min, max, defaultProps.value);
  var step = getStepFromProps(propStep, defaultProps.step, max, min); // Define local state and define initial values

  var _useState = (0, _react.useState)({
    value: value,
    enteredValue: value,
    isValid: true
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1]; // Update internal value whenever the value prop from outside changes


  (0, _useAfterMount.default)(function () {
    setState({
      value: getValueFromProps(propValue, min, max, defaultProps.value),
      enteredValue: value,
      isValid: true
    });
  }, [propValue, clampNumber]);

  var applyValue = function applyValue(newValue) {
    if (isFormatted(newValue)) {
      if (newValue === '-' || newValue === '') {
        setState({
          value: newValue,
          enteredValue: newValue,
          isValid: true
        });
      } else {
        var enteredValue = Number(newValue);
        var isValid = enteredValue >= min && enteredValue <= max;
        var newValidValue = clampNumber(enteredValue, min, max);
        setState({
          value: newValidValue,
          enteredValue: enteredValue,
          isValid: isValid
        }); // Only call back the caller for valid values

        isValid && onValueChanged(newValidValue);
      }
    }
  };

  var handleOnChange = function handleOnChange(event) {
    return applyValue(event.target.value);
  };

  var handleBlur = function handleBlur(event) {
    // console.log({enteredValue: state.enteredValue, event: Number(event.target.value)});
    // When the vales is removed, keep the input empty but trigger the onValueChanged callback
    // since the user has finished his input
    var lastEnteredValue = state.enteredValue;

    if (lastEnteredValue === '') {
      onValueChanged(lastEnteredValue);
      return;
    } // Otherwise, validate the input and calmp it if the entered value exeeds the limitations


    var convertedEnteredValue = convertNonIntegerToDefault(Number(lastEnteredValue), min);
    var validNumber = clampNumber(convertedEnteredValue, min, max);
    applyValue(validNumber);
  };

  var inputGroupClassNames = (0, _classnames.default)('input-group', bsSize === 'sm' && 'input-group-sm', bsSize === 'lg' && 'input-group-lg');
  var inputClassNames = (0, _classnames.default)('form-control', 'no-controls', bsSize === 'sm' && 'input-sm', bsSize === 'lg' && 'input-lg', className);

  var input = /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, remainingProps, {
    type: type,
    step: step,
    min: min,
    max: max,
    value: state.isValid ? state.value : state.enteredValue,
    className: inputClassNames,
    disabled: disabled,
    onBlur: handleBlur,
    onChange: handleOnChange,
    ref: ref,
    "aria-label": 'number-input'
  }));

  return unit || inputAddon ? /*#__PURE__*/_react.default.createElement("div", {
    className: inputGroupClassNames
  }, inputAddon && /*#__PURE__*/_react.default.createElement("span", {
    className: 'input-group-addon'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: inputAddon
  })), input, unit && /*#__PURE__*/_react.default.createElement("span", {
    className: 'input-group-addon'
  }, unit)) : input;
});

NumberInput.propTypes = {
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  value: _propTypes.default.number,
  step: _propTypes.default.number,
  type: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onValueChanged: _propTypes.default.func,
  bsSize: _propTypes.default.oneOf(['sm', 'lg', 'small', 'large']),
  className: _propTypes.default.string,
  unit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  inputAddon: _propTypes.default.string
};
var _default = NumberInput;
exports.default = _default;